import { render, staticRenderFns } from "./evaluate-list.vue?vue&type=template&id=c27771d8&scoped=true&"
import script from "./evaluate-list.vue?vue&type=script&lang=js&"
export * from "./evaluate-list.vue?vue&type=script&lang=js&"
import style0 from "./evaluate-list.vue?vue&type=style&index=0&id=c27771d8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c27771d8",
  null
  
)

export default component.exports